import {
  EProgressBarInternalViewModel,
  JunesJourneyProgressBar,
  OfferProgressBar,
  PlaystudiosProgressBar
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultProgressBar: BlockMetadata = {
  id: EProgressBarInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/progress-bar/default_preview.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: OfferProgressBar
};

const defaultKonamiSlots: BlockMetadata = {
  id: EProgressBarInternalViewModel.KONAMI_SLOTS,
  version: '1.0.0',
  name: 'Konami Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/Playstudios/progress-bar-konami-slots.png'
  ],
  theme: EThemes.PLAYSTUDIOS,
  component: PlaystudiosProgressBar
};

const defaultJunesJourney: BlockMetadata = {
  id: EProgressBarInternalViewModel.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/progress-bar/wooga-progres-bar.png'
  ],
  theme: EThemes.JUNES_JOURNEY,
  component: JunesJourneyProgressBar
};

const defaultMilestone: BlockMetadata = {
  id: EProgressBarInternalViewModel.MILESTONE_DEFAULT,
  version: '1.0.0',
  name: 'Milestone',
  createdAt: '2025-01-01T00:00:00.000Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/progress-bar/milestones-default-template-2.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: OfferProgressBar
};

export const progressBarsDesigns = {
  defaultProgressBar,
  defaultKonamiSlots,
  defaultJunesJourney,
  defaultMilestone
};
